/**
 * Class that helps wih drag and drop of items in component
 * dinapsis-map-layer-manager
 */
export default class DragAndDropHelper {
    constructor(componentId, callback) {
        // Id of component dinapsis-map-layer-manager
        // We use it in order to prevent errors whith drag and drop if there are many maps in a page
        this.componentId = '';
        // The overlay layers
        this.overlayLayers = [];
        // The id of the layer that is being moved
        this.layerIdMoved = '';
        // The index of the layer that is being moved
        this.layerIndexMoved = '';
        this.callback = callback;
        this.componentId = componentId;
        // We bind functions to current class in order to use 'this' inside functions
        // as a DragAndDropHelper instance
        this.handleDragStart = this.handleDragStart.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleDragEnter = this.handleDragEnter.bind(this);
        this.handleDragLeave = this.handleDragLeave.bind(this);
        this.handleDragEnd = this.handleDragEnd.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
    }
    /**
     * Methd that set events to each layer item
     * @param overlayLayers The current overlay layers
     */
    initializeDragAndDrop(overlayLayers) {
        this.overlayLayers = overlayLayers;
        for (let i = 0; i < overlayLayers.length; i += 1) {
            const overlayLayer = overlayLayers[i];
            const layerItem = document.getElementById(`${this.componentId}_layer_item_${overlayLayer.id}`);
            if (layerItem && layerItem.getAttribute('fixedIndex') === 'false') {
                layerItem.removeEventListener('dragstart', this.handleDragStart);
                layerItem.removeEventListener('dragover', this.handleDragOver);
                layerItem.removeEventListener('dragenter', this.handleDragEnter);
                layerItem.removeEventListener('dragleave', this.handleDragLeave);
                layerItem.removeEventListener('dragend', this.handleDragEnd);
                layerItem.removeEventListener('drop', this.handleDrop);
                layerItem.addEventListener('dragstart', this.handleDragStart);
                layerItem.addEventListener('dragover', this.handleDragOver);
                layerItem.addEventListener('dragenter', this.handleDragEnter);
                layerItem.addEventListener('dragleave', this.handleDragLeave);
                layerItem.addEventListener('dragend', this.handleDragEnd);
                layerItem.addEventListener('drop', this.handleDrop);
            }
        }
    }
    /**
     * Method to remove events in order to avoid memory leaks
     */
    remove() {
        for (let i = 0; i < this.overlayLayers.length; i += 1) {
            const overlayLayer = this.overlayLayers[i];
            const layerItem = document.getElementById(`${this.componentId}_layer_item_${overlayLayer.id}`);
            if (layerItem && layerItem.getAttribute('fixedIndex') === 'false') {
                layerItem.removeEventListener('dragstart', this.handleDragStart);
                layerItem.removeEventListener('dragover', this.handleDragOver);
                layerItem.removeEventListener('dragenter', this.handleDragEnter);
                layerItem.removeEventListener('dragleave', this.handleDragLeave);
                layerItem.removeEventListener('dragend', this.handleDragEnd);
                layerItem.removeEventListener('drop', this.handleDrop);
            }
        }
    }
    /**
     * Drag has started
     * @param e Event
     */
    handleDragStart(e) {
        // Make more transparent the element we
        // started dragging that stays in its position
        e.target.style.opacity = '0.4';
        this.layerIdMoved = e.target.getAttribute('layerId');
        this.layerIndexMoved = e.target.getAttribute('layerIndex');
        // Set browser drag style
        if (e && e.dataTransfer) {
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', e.target.innerHTML);
        }
    }
    /**
     * Drag ended
     * @param e Event
     */
    handleDragEnd(e) {
        // Reset opacity to element when ended being moved
        e.target.style.opacity = '1';
        // Find all separators
        const separators = document.getElementsByClassName('layer-item-separator');
        // Remove active flag (the one that shows in blue the separator)
        // in all separator elements when drag ended
        for (let i = 0; i < separators.length; i += 1) {
            const separator = separators[i];
            if (separator) {
                separator.classList.remove('active');
            }
        }
    }
    /**
     * Activate the separator
     * @param container The container of the layer item we area over
     */
    activateSeparator(container) {
        const newIndex = container.getAttribute('layerIndex');
        let separator;
        // Get separator that has to be activated.
        // If element dragged was above element over activate the one above
        // else activate the one bellow
        if (newIndex && this.layerIndexMoved > newIndex) {
            separator = container.previousElementSibling;
        }
        else {
            separator = container.nextElementSibling;
        }
        // Activate separator if we arenot above the same element being moved
        if (separator && separator.classList.contains('layer-item-separator')) {
            const separatorLayerId = separator.getAttribute('layerId');
            if (separatorLayerId !== this.layerIdMoved) {
                separator.classList.add('active');
            }
        }
    }
    /**
     * Drag over element
     * @param e Event
     * @returns False
     */
    handleDragOver(e) {
        if (e.preventDefault) {
            e.preventDefault();
        }
        // Find the container of the item we are over
        const container = e.target.closest('.draggable-layer-item-container');
        // Activate separator
        this.activateSeparator(container);
        return false;
    }
    /**
     * Drag enter on element
     * @param e Event
     */
    handleDragEnter(e) {
        // Find the container of the item we have entered
        const container = e.target.closest('.draggable-layer-item-container');
        // Activate separator
        this.activateSeparator(container);
    }
    /**
     * Handle leave
     * @param e Event
     */
    handleDragLeave(e) {
        let separator;
        // Find the container of the item we have leaved
        const container = e.target.closest('.draggable-layer-item-container');
        // Get separator that has to be inactivated.
        // If element dragged was above element over activate the one above
        // else activate the one bellow
        const newIndex = container.getAttribute('layerIndex');
        if (this.layerIndexMoved > newIndex) {
            separator = container.previousElementSibling;
        }
        else {
            separator = container.nextElementSibling;
        }
        if (separator && separator.classList.contains('layer-item-separator')) {
            separator.classList.remove('active');
        }
    }
    /**
     * Handle drop
     * @param e Event
     * @returns False
     */
    handleDrop(e) {
        e.stopPropagation();
        // Find the separator we have dropped on
        let separator;
        if (e.target.classList.contains('layer-item-separator')) {
            separator = e.target;
        }
        else {
            const container = e.target.closest('.draggable-layer-item-container');
            separator = container.previousElementSibling;
        }
        // If item being dragged has been dropped on an element
        // different to itself, execute callback in order to inform of
        // layer moved and its new position
        const newIndex = separator.getAttribute('layerIndex');
        if (this.layerIdMoved && this.layerIndexMoved !== newIndex) {
            this.callback(this.layerIdMoved, newIndex);
        }
        // Inactive separators once element has been dropped
        if (separator && separator.classList.contains('layer-item-separator')) {
            separator.classList.remove('active');
        }
        return false;
    }
}
//# sourceMappingURL=drangAndDrop.js.map